import styled from 'styled-components';

const ProgrammingStyles = styled.div``;

export default ProgrammingStyles;
